module.exports = __webpack_public_path__ + "static/media/Mr Tao Tan.c452c726.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/Mr Tao Tan.jpg
// module id = 182
// module chunks = 0